import $ from 'jquery';
import '../src/js/vendor/jquery.tablesorter';
import '../src/js/tablesorter-ext';
import tabs from '../src/js/tabs.js';
import invoiceForm from '../src/js/backend/invoice-form';
import utils from '../src/js/backend/utils';
import toggleElement from '../src/js/backend/toggle-element';
tabs();
invoiceForm();
utils();
toggleElement();
if ($('[data-table-sorter]').length) {
  $('[data-table-sorter]').tablesorter({
    textExtraction(node) {
      return node.getAttribute('data-sort') || $(node).text();
    },
  });
}
